import React from 'react';
import PropTypes from 'prop-types';

import useAppContext from '../../context/useAppContext';

import Widget from '../../models/widget';
import { Route, Switch } from 'react-router-dom';
import Template from '../../components/template/template';
import Loading from '../../components/loading';
import PageError from '../../pages/error/pageError';
import { ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { ManagerContextProvider } from '../../pages/manager/components/context';
import PersonalSpaceSettings from '../../pages/widgets/personal_spaces/details/settings';
import PersonalSpaceTranslations from '../../pages/widgets/personal_spaces/details/translations';

export default function PersonalSpaceRouter({ path, organization, personalSpaceId, history }) {
    const [context, setContext] = useAppContext();
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();

    const [, loading] = Widget.useApiModel(
        {
            id: personalSpaceId,
            organizationId: organization.id,
            query: {
                usage__in: ['personal_space', 'moderation']
            },
            onSuccess: personal_space => {
                setContext({ personal_space });
            },
            onError: e => {
                if (e.code === 404) {
                    toast.error(t('pageNotFound'));
                } else {
                    toast.error(t('ticket.common.toast_error'));
                }

                history.push(`/ticket/O${organization.id}/personal_spaces`);
            }
        },
        [personalSpaceId, organization, t, history]
    );

    if (loading || !context.personal_space) {
        return <Loading />;
    }

    return (
        <ManagerContextProvider>
            <Template organization={organization} personal_space={context.personal_space}>
                <Switch>
                    <Route
                        exact
                        path={`${path}/settings`}
                        render={({
                            match: {
                                params: { personalSpaceId }
                            }
                        }) => <PersonalSpaceSettings organization={organization} personalSpaceId={personalSpaceId} />}
                    />
                    <Route
                        exact
                        path={`${path}/translations`}
                        render={({
                            match: {
                                params: { personalSpaceId }
                            }
                        }) => <PersonalSpaceTranslations organization={organization} personalSpaceId={personalSpaceId} />}
                    />
                    {/* Error */}
                    <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}/personal_spaces/${personalSpaceId}`} />} />
                </Switch>
            </Template>
        </ManagerContextProvider>
    );
}

PersonalSpaceRouter.propTypes = {
    match: PropTypes.string,
    organization: PropTypes.object,
    history: PropTypes.object.isRequired,
    personalSpaceId: PropTypes.string
};
